import { TaskCard } from '@medely/ui-kit';
import React from 'react';
import { TaskCardLayout } from '../TaskCard';

type SetYourselfUpInfoProps = {
  onClick: () => void;
  title?: string;
  body?: string;
  iconName?: any;
};

export const SetYourselfUpInfo = ({
  onClick,
  title = 'Set yourself up for success',
  body = 'Learn how to find and book shifts with Medely.',
  iconName = 'light-info-circle',
}: SetYourselfUpInfoProps) => {
  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: iconName, color: 'primary' }}
        title={title}
        body={body}
        onClick={onClick}
      />
    </TaskCardLayout>
  );
};
